import { Injectable, EventEmitter } from '@angular/core';
import { IEbookRoutingService } from './ebook-routing.service.interface';
import { Router, NavigationExtras, NavigationEnd } from '@angular/router';
import { from, Observable } from 'rxjs';
import { AppRoutes } from '../../../shared/Constants/app-routes';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { Book } from '../../models/book';
import { localStorageKeys } from '../../../shared/Constants/local-storage-keys';
import { UserSessionService } from '../../../shared/services/user-session/user-session.service';

@Injectable({
  providedIn: 'root'
})
export class EbookRoutingService implements IEbookRoutingService {

  public onRouteChange: EventEmitter<string> = new EventEmitter();
  private routesToReplaceurl = [AppRoutes.ebookPlayer];
  //a hack used to force removing ebookPlayer page from navigationStack
  private eBookPlayerPageState: { isOpened: boolean, ISBN: string, book: Book } = { isOpened: false, ISBN: null, book: null };

  constructor(private router: Router,
    private _localStorageService: LocalStorageService,
    private _userSessionService: UserSessionService) {
    _userSessionService.sessionStateChanged().subscribe(isActive => {
      if (!isActive) {
        this.removeEbookPlayerState();
      }
    });
    this.handleRouterEvents();
  }

  public navigate(url, navigationExtras: NavigationExtras = null): Observable<boolean> {
    if (navigationExtras && this.routesToReplaceurl.indexOf(this.router.url) > -1) {
      navigationExtras.replaceUrl = false;
    }
    return from(navigationExtras ? this.router.navigateByUrl(url, navigationExtras) : this.router.navigateByUrl(url));
  }

  public getCurrentNavigationExtras(): NavigationExtras {
    return this.router.currentNavigation().extras;
  }

  public getEbookPlayerState(): any {
    return this._localStorageService.getFromLocalStorage(localStorageKeys.EBookPlayerPageState);
  }

  public removeEbookPlayerState(): any {
    return this._localStorageService.deleteFromLocalStorage(localStorageKeys.EBookPlayerPageState);
  }

  public setEbookPlayerState(isbn: string, isopen: boolean, book?: Book) {
    this.eBookPlayerPageState.ISBN = isbn;
    this.eBookPlayerPageState.isOpened = isopen;
    this.eBookPlayerPageState.book = book;
    this._localStorageService.saveToLocalStorage(localStorageKeys.EBookPlayerPageState, this.eBookPlayerPageState);
  }

  private handleRouterEvents() {
    return this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.onRouteChange.emit(event.url);
      }
    });
  }
}
